import { render, staticRenderFns } from "./appDownloadPage.vue?vue&type=template&id=9047764a&scoped=true&"
import script from "./appDownloadPage.vue?vue&type=script&lang=js&"
export * from "./appDownloadPage.vue?vue&type=script&lang=js&"
import style0 from "./appDownloadPage.vue?vue&type=style&index=0&id=9047764a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9047764a",
  null
  
)

export default component.exports